import { forwardRef } from "react";

import { cn } from "@/lib/utils";

const ToolbarButton: React.FC<
  React.PropsWithChildren<React.ComponentProps<"button">>
> = forwardRef(({ children, className, ...props }, ref) => {
  return (
    <button
      // Ensure toolbar buttons inside forms don't submit the form by default
      // and behave like typical toolbar controls.
      type={(props as any).type || "button"}
      className={cn(
        "flex size-8 items-center justify-center rounded-md p-1 text-slate-900 transition-colors hover:bg-primary/10",
        className
      )}
      ref={ref}
      {...props}
    >
      {children}
    </button>
  );
});

export default ToolbarButton;
